import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import {
  type AhaReferenceElement,
  type ComponentProps,
} from '@aha-app/aha-editor-v2';
import ReferenceAhaElement from './ReferenceAhaElement';
import type BatchedRecordLoader from 'components/framework/BatchedRecordLoader';

interface ReferenceAhaComponentProps
  extends ComponentProps<AhaReferenceElement> {
  children?: React.ReactNode;
  isModifiable: boolean;
  batchedRecordLoader: BatchedRecordLoader;
}

const ReferenceAhaComponent: React.FC<ReferenceAhaComponentProps> = ({
  attributes,
  element,
  children,
  batchedRecordLoader,
  isModifiable,
}) => {
  return (
    <span {...attributes}>
      {children}
      <ReferenceAhaElement
        element={element}
        batchedRecordLoader={batchedRecordLoader}
        isModifiable={isModifiable}
      />
    </span>
  );
};

export default ApplicationView(ReferenceAhaComponent);
